<script>
  import Modal from "@/components/atoms/Modal.svelte";
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, string, bool, array } = PropTypes;

  export let navLinks, opened, theme;
  const hasForcedTheme = theme !== undefined;
  const themeClasses = hasForcedTheme
    ? `${theme === "dark" ? "bg-black text-white" : "bg-white text-black"}`
    : "bg-white dark:bg-black text-black dark:text-white";

  const propTypes = {
    navLinks: array,
    opened: bool,
    theme: string,
  };

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "WikiMenu");
  });
</script>

<Modal show={opened} bgc="bg-modal">
  <div
    class={`flex flex-col pt-20 pb-md ${themeClasses}`}
    data-testid="mobile-menu"
  >
    {#each navLinks as link}
      <a href={link.r} class="py-sm px-10 leading-[1.2] font-semibold"
        >{link.n}</a
      >
    {/each}
  </div>
</Modal>
